import React, { Fragment } from 'react';

export const SelectIndicatorSeparator = () => <Fragment />;

export const SelectIndicatorSeparatorStyles = () => ({});
